<template>
  <div>
  <div class="grid-container full footer">
    <div class="grid-x page-contents-8" >
      <div class=" small-12 medium-7 cell">
        <div class="grid-x menuCont">
          <div class="small-12 medium-5 cell">
            <ul class="footerList">
              <router-link tabindex="101" @keypress.native="navigate('/news')" tag="li" to="/news">News, Press & Awards</router-link>
              <router-link tabindex="102" @keypress.native="navigate('/work-for-rare')" tag="li" to="/work-for-rare">Work for Rare</router-link>
              <router-link tabindex="103" @keypress.native="navigate('/modern-slavery-statement')" tag="li" to="/modern-slavery-statement">Modern Slavery Statement</router-link>
            </ul>
          </div>
          <div class="small-12 medium-4 cell">
            <ul class="footerList">
              <router-link tabindex="104" @keypress.native="navigate('/website-terms-of-use')" tag="li" to="/website-terms-of-use">Website Terms of Use</router-link>
              <router-link tabindex="105" @keypress.native="navigate('/accessibility-policy')" tag="li" to="/accessibility-policy">Accessibility Policy</router-link>
              <router-link tabindex="106" @keypress.native="navigate('/privacy-policy')" tag="li" to="/privacy-policy">Privacy Policy</router-link>
              <router-link tabindex="107" @keypress.native="navigate('/cookie-policy')" tag="li" to="/cookie-policy">Cookie Policy</router-link>
            </ul>
          </div>
          <div class="small-12 medium-3">
            <a tabindex="108" href="https://twitter.com/rare_london?lang=en" class="twitterIcon" target="_blank" rel="noopener">
              <img src="@/assets/img/logos/footer/x.png" alt="X logo" class="social-media-icon" />
            </a>
            <a tabindex="109" href="https://www.linkedin.com/company/rare-recruitment" class="linkedinIcon" target="_blank" rel="noopener">
              <img src="@/assets/img/logos/footer/linkedin.png" alt="Linkedin logo" class="social-media-icon" />
            </a>
          </div>
        </div>

        <form id="rare-newsletter-form">
          <!-- Hubspot form goes here -->
        </form>

      </div>
      <div class=" small-12 medium-5 cell">
        <div class="grid-x iconCont">
          <div class="auto cell">
            <a href="https://www.cyberessentials.ncsc.gov.uk/" target="_blank" rel="noopener">
            <img
              class="accredLogo cyber"
              src="@/assets/img/logos/cyber-essentials.png" alt="Cyber Essentials Logo"/>
            </a>
          </div>
          <div class="auto cell">
            <a href="https://www.gov.uk/data-protection" target="_blank" rel="noopener">
            <img
              class="accredLogo gdpr"
              src="@/assets/img/logos/gdpr-logo.png" alt="GDPR Logo"/>
            </a>
          </div>
          <div class="auto cell">
            <img
              class="accredLogo iso"
              src="@/assets/img/logos/ISO-27001-ukas.png" alt="ISO 27001 Logo"/>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-x page-contents-8 footerBase" >
      <div class=" small-12 cell">
        <p>&copy; Rare Recruitment Ltd. All Rights Reserved.</p>
      </div>
    </div>
  </div>

    <!-- THANKS MODAL -->
    <div v-if="signUpSuccessful" id="thanksModal">
      <div id="thanksInner">
        <rare-modal-close-icon-large
          class="rareModalCloseIcon"
          @clicked="closeThankYouModal"
        />

        <h2>Thank you</h2>
        <p>You have Successfully signed up to our newsletter.</p>
        <rare-standard-button
          :active="'true'"
          :width="'200px'"
          :height="'40px'"
          :fontSize="'14px'"
          :buttonText="'Close'"
          @clicked="closeThankYouModal"
        />
      </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';

export default {
  name: 'RareFooter',
  components: {
    'rare-newsletter-button': RareStandardButton,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
    'rare-standard-button': RareStandardButton,
  },
  data() {
    return {
      legalModalOpen: false,
      legalModalHeader: null,
      legalModalContent: null,
      signUpText: 'Sign Up',
      signUpSuccessful: false,
      oldYPos: 0,
    };
  },
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '27067983',
          formId: '1c5bf309-b0b3-4fac-a800-a09dad3b4f3b',
          target: '#rare-newsletter-form',
          onFormSubmitted: () => {
            this.openThankYouModal();
          },
        });
      }
    });
  },
  methods: {
    navigate(path) {
      this.$router.push(path);
    },
    openLegalModal(header, content) {
      this.oldYPos = window.pageYOffset;
      window.scrollTo(0, 0);
      this.legalModalHeader = header;
      this.legalModalContent = content;
      this.legalModalOpen = true;
    },
    closeLegalModal() {
      window.scrollTo(0, this.oldYPos);
      this.legalModalOpen = false;
    },
    closeThankYouModal() {
      this.signUpSuccessful = false;
    },
    openThankYouModal() {
      this.signUpSuccessful = true;
    },
  },
  watch: {
    $route() {
      this.closeLegalModal();
      this.closeThankYouModal();
    },
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .footer {
    border-top: 1px solid #c4cace;
  }

  .footerList {
    list-style: none;
    padding: 0;
    margin: 0 0 0 0;
  }

  .footerList li {
    color: $main-text;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    cursor: pointer;
  }

  .buttonWrapper {
    display: inline-block;
  }

  .emailLabel {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    margin: 0;
    margin-bottom: 8px;
    text-align: left;
  }

  .accredLogo {
    display: inline-block;
    float: right;
  }

  .footerBase {
    background-color: $dark-grey-background;
    color: #ffffff;
    font-size: 10px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    height: 35px;
    line-height: 35px;
    text-align: left;
  }

  .footerBase p {
    padding: 0;
    line-height: 35px;
    margin: 0;
  }

  .social-media-icon {
    width: 32px;
    height: 32px;
  }

  input.pass {
    border: 2px solid #A7CD5F;
    background-image: url('~@/assets/img/icons/pass.svg');
    background-position: 97%;
    background-repeat: no-repeat;
  }

  input.fail {
    border: 2px solid #ff495c;
    background-image: url('~@/assets/img/icons/fail.svg');
    background-position: 97%;
    background-repeat: no-repeat;
  }

  @media only screen and (max-width: 640px)  {

    .menuCont {
      margin-top: 27px;
    }


    .emailCont {
      margin: 20px 0 33px 0;
    }

    .emailLabel {
      font-size: 12px;
      line-height: 2;
    }

    .emailInput {
      height: 32px;
      border-radius: 16px;
      margin-right: 5px;
      width: 181px;
    }


    .footerList li {
      font-size: 12px;
      line-height: 2;
    }

    .linkedinIcon {
      display: inline-block;
      margin-left: 4px;
      margin-top: 25px;
    }

    .twitterIcon {
      display: inline-block;
      margin-left: 0;
      margin-top: 25px;
    }

    .iconCont {
      margin-bottom: 30px;
      margin-top: -12px;
    }


    .cyber {
      max-width: 70px;
    }

    .gdpr {
      max-width: 66px;
    }
    .iso {
      max-width: 60px;
    }


  }

  @media only screen and (min-width: 641px)  {

    .menuCont {
      margin-top: 37px;
    }

    .emailCont {
      margin: 30px 0 33px 0;
    }

    .emailLabel {
      font-size: 14px;
      line-height: 1.71;
    }

    .emailInput {
      margin-right: 11px;
      width: 392px;
    }


    .footerList li {
      font-size: 14px;
      line-height: 1.71;
    }

    .linkedinIcon {
      display: inline-block;
      margin-left: 4px;
    }

    .twitterIcon {
      display: inline-block;
      margin-left: 12px;
    }

    .iconCont {
      margin-top: 37px;
    }

    .cyber {
      max-width: 90px;
    }

    .gdpr {
      max-width: 100px;
    }
    .iso {
      max-width: 80px;
    }


  }
  #thanksModal {
    display: flex;
    position: fixed;
    z-index: 99999;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  #thanksInner {
    position: relative;
    width: 800px;
    height: 350px;
    background-color: white;
    text-align: left;
    padding: 0 70px 0 70px;
  }

  .rareModalCloseIcon {
    position: absolute;
    cursor: pointer;
    right: 0%;
    top: 0%;
    margin-top: 10px;
    margin-right: 20px;
  }

  #thanksInner h2 {
    font-size: 32px;
    font-weight: normal;
    margin-top: 75px;
    margin-bottom: 30px;
  }

  #thanksInner p {
    font-size: 24px;
    margin-bottom: 3rem;
    text-align: left;
  }


</style>



// WEBPACK FOOTER //
// src/components/commonSections/RareFooter.vue